import { useEffect, useMemo, useReducer } from 'react';
import { isSubscriptionStart, } from './types';
import { useConnectContext } from './connect-context';
import { hash } from './utils';
function statusReducer(state, action) {
    if (action.type === 'loading') {
        return state.loading
            ? state
            : { error: null, loading: true, result: undefined };
    }
    if (action.type === 'error') {
        return state.error === action.error
            ? state
            : { error: action.error, loading: false, result: undefined };
    }
    if (action.type === 'done') {
        return hash(state.result) === hash(action.result)
            ? state
            : { error: null, loading: false, result: action.result };
    }
    return state;
}
const statusInitial = {
    error: null,
    loading: true,
    result: undefined,
};
export function useConnect(callback, dependencies) {
    const { org, orgStatus } = useConnectContext();
    const [{ result, error, loading }, setStatus] = useReducer(statusReducer, statusInitial);
    if (callback === undefined) {
        callback = ((org) => org);
    }
    useEffect(() => {
        let cancelled = false;
        let subscriptionHandler = null;
        const update = async () => {
            setStatus({ type: 'loading' });
            try {
                if (!org) {
                    if (orgStatus.error !== null) {
                        setStatus({ type: 'error', error: orgStatus.error });
                    }
                    return;
                }
                const result = await callback(org);
                if (cancelled || result === undefined) {
                    return;
                }
                // Subscription
                if (isSubscriptionStart(result)) {
                    subscriptionHandler = result((error, result) => {
                        if (cancelled) {
                            return;
                        }
                        if (error) {
                            setStatus({ type: 'error', error });
                            return;
                        }
                        setStatus({ type: 'done', result });
                    });
                    // Just async data
                }
                else {
                    setStatus({ type: 'done', result });
                }
            }
            catch (err) {
                if (!cancelled) {
                    setStatus({ type: 'error', error: err });
                }
            }
        };
        update();
        return () => {
            cancelled = true;
            subscriptionHandler === null || subscriptionHandler === void 0 ? void 0 : subscriptionHandler.unsubscribe();
        };
    }, [org, ...(dependencies || [])]);
    return useMemo(() => [result, { error, loading, retry: () => null }], [
        result,
        error,
        loading,
    ]);
}
//# sourceMappingURL=use-connect.js.map